import AppLayoutAdmin from "@/layouts/AppLayoutAdmin.vue";
import NotificationList from "@/pages/notification/NotificationList.vue";
import TableauBord from "@/pages/dashboard/TableauBord.vue";

export default   {
    path: "/",
    component: AppLayoutAdmin,
    meta: { requiredAuth: true },
    children: [
        {
            path: "",
            name: "DashboardS",
            component: TableauBord
        },
        {
            path: "dashboard",
            name: "Dashboard",
            component: TableauBord
        },
        {
            path: 'notifications',
            meta: { permissions: ["view_notification"] },
            name: "NotificationList",
            component: NotificationList,
    
        },
    ]
}